import { isPlatformAdmin } from './isPlatformAdmin';

const CCC_MANAGER_TENANTS = new Set(['ccc', 'comercial', 'callcenter', 'admin']);

function hasCccTenantAccess(tenant: string): boolean {
  return CCC_MANAGER_TENANTS.has(tenant);
}

function isCccMemberUser(user?: Record<string, unknown> | null): boolean {
  if (!user) return false;
  const tenant = String(user.tenant || '').toLowerCase();
  if (hasCccTenantAccess(tenant)) return true;
  const role = String(user.role || '').toLowerCase();
  const area = String(user.business_area || '').toLowerCase();
  const team = String(user.team || '').toUpperCase();
  return team === 'CCC' || role.includes('ccc') || area.includes('ccc');
}

/** CCC Coordenador (Gerente) or platform Admin — team user picker / browse all workspaces. */
export function isCccCoordenadorOrAdmin(user?: Record<string, unknown> | null): boolean {
  if (isPlatformAdmin(user)) return true;
  if (!isCccMemberUser(user)) return false;

  const role = String(user?.role || '').trim();
  const rl = role.toLowerCase();
  const tenant = String(user?.tenant || '').toLowerCase();
  const businessArea = String(user?.business_area || '').toLowerCase();

  if (tenant === 'admin' || businessArea === 'admin') {
    if (rl.includes('admin')) return true;
  }

  if (
    role === 'Call Center Manager' ||
    role === 'Commercial Director' ||
    rl.includes('call center manager') ||
    rl.includes('commercial director')
  ) {
    return true;
  }

  if (rl === 'gerente' || rl.includes('função gerente')) {
    return true;
  }

  if (rl.includes('coordenador') || rl.includes('coordinator')) {
    return true;
  }

  return false;
}

/** Gerente or platform Admin may open Gestão de Utilizadores CCC. */
export function canManageCccUsers(user?: Record<string, unknown> | null): boolean {
  return isCccCoordenadorOrAdmin(user);
}

/** All CCC roles may open the Recuperação workspace. */
export function canAccessRecuperacao(user?: Record<string, unknown> | null): boolean {
  if (isPlatformAdmin(user)) return true;
  return isCccMemberUser(user);
}
